import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const ImgAvatarStyle = (theme: Theme) => createStyles({
  small: {
    // width: '48px!important',
    // height: '48px!important',
  },
  medium: {
    // width: '34px!important',
    // height: '34px!important',
  },
  border: {
    borderStyle: 'solid',
    borderColor: styleColors.transparentBlack,
    borderWidth: '3px',
    boxSizing: 'border-box',
  },
  selected: {
    borderColor: styleColors.coralRed,
  },
  avatar: {
    width: '40px',
    height: '40px',
    display: 'flex',
    overflow: 'hidden',
    position: 'relative',
    alignItems: 'center',
    flexShrink: 0,
    userSelect: 'none',
    borderRadius: '50%',
    justifyContent: 'center',
  },
  avatarImage: {
    color: styleColors.transparent,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    textAlign: 'center',
    // textIndent: '10000px',
  },
  greyAvatarImage: {
    filter: 'grayscale(100%)',
  }
});



// WEBPACK FOOTER //
// ./src/components/common/avatar/ImgAvatar.style.ts